const CARD_BRAND_MAP = {
  VISA: 'Visa',
  MASTERCARD: 'MasterCard',
  MAESTRO: 'Maestro',
  MIR: 'MIR',
  JCB: 'JCB',
};

const CARD_ICONS_DESKTOP = {
  Visa: require('../BankCardList/DesktopView/assets/Visa.svg').default,
  MasterCard: require('../BankCardList/DesktopView/assets/MasterCard.svg').default,
  Maestro: require('../BankCardList/DesktopView/assets/Maestro.svg').default,
  MIR: require('../BankCardList/DesktopView/assets/MIR.svg').default,
  JCB: require('../BankCardList/DesktopView/assets/JCB.svg').default,
};

const CARD_ICONS_MOBILE = {
  Visa: require('../BankCardList/MobileView/assets/Visa.svg').default,
  MasterCard: require('../BankCardList/MobileView/assets/MasterCard.svg').default,
  Maestro: require('../BankCardList/MobileView/assets/Maestro.svg').default,
  MIR: require('../BankCardList/MobileView/assets/MIR.svg').default,
  JCB: require('../BankCardList/MobileView/assets/JCB.svg').default,
};

export function getPayuCardDisplay(card) {
  // New secure schema: { id, last_four, card_type }
  const lastFour = card?.last_four || (card?.cardNumberMasked || '').replace(/\*/g, '').slice(-4) || '****';
  const brand = card?.card_type || card?.cardBrand || '';
  const cardType = CARD_BRAND_MAP[brand?.toUpperCase()] || brand || 'Unknown';
  return { lastFour, cardType };
}

export function getCardIconDesktop(cardType) {
  return CARD_ICONS_DESKTOP[cardType] || null;
}

export function getCardIconMobile(cardType) {
  return CARD_ICONS_MOBILE[cardType] || null;
}
